import { useForm } from 'react-hook-form';
import ReviewForm from './ReviewForm';
import ReviewProductItem from './ReviewProductItem';
import ReviewRating from './ReviewRating';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { modifyReview, submitProductReview } from 'store/actions';
import { useSubmit } from 'shared/hooks';
import { toast } from 'react-toastify';
import { routeConstants } from 'shared/constants';
import moment from 'moment';

const ReviewRightBlock = ({ reviewDetail, productData }) => {
  const modifiedReview = useSelector((state) => state.reviews.modifiedReview);
  const reviewError = useSelector((state) => state.reviews.error);
  const modifying = useSelector((state) => state.reviews.modifying);
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: reviewDetail
      ? {
          title: reviewDetail.title,
          description: reviewDetail.description,
          rating: reviewDetail.rating.toString(),
        }
      : { rating: '4' },
  });
  const { changeStatus } = useSubmit({
    loading: modifying,
    data: modifiedReview,
    error: reviewError,
    onSuccess: () => {
      toast.success('Thank you for your review');
      history.push(routeConstants.ACCOUNT.subRoutes.MANAGE_ORDERS.path);
    },
  });

  const onSubmit = (data) => {
    reviewDetail
      ? dispatch(
          modifyReview({ formData: { ...data }, reviewId: reviewDetail._id })
        )
      : dispatch(
          submitProductReview({ ...data, product: productData.product._id })
        );
    changeStatus(true);
  };

  const ratingValue = watch('rating');
  const deliveryDate = productData.orderStatus
    ? productData.orderStatus.find((status) => status.name === 'delivered')
    : undefined;

  return (
    <div className="review_right_block">
      <div className="review_outline_wrap">
        <form onSubmit={handleSubmit(onSubmit)} className="cart_section">
          <ReviewProductItem
            productData={productData.product}
            price={productData.taxedAmount}
            date={deliveryDate ? moment(deliveryDate.date).format('ll') : ''}
          />
          <ReviewRating register={register} ratingValue={ratingValue} />
          <div className="write_revw">
            <div className="rate_item">
              <h6>Rate this product</h6>
            </div>
            <ReviewForm
              errors={errors}
              register={register}
              loading={modifying}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReviewRightBlock;
